import { faCircleNotch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const Loader = () => {
  return (
    <div id="loader" className="hidden fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/40" />

      {/* Spinner */}
      <div className="relative">
        <FontAwesomeIcon
          icon={faCircleNotch}
          className="text-white text-4xl animate-spin"
        />
      </div>
    </div>
  )
}

export default Loader
